import CTypography from 'components/CTypography';
import AddIcon from 'components/Icons/addIcon';
import CustomInput from 'components/Form/TextField/TextField.cmp';
import {
  AssigneeCnt,
  CategoryCnt,
  CrossIconBtn,
  LocationCnt,
  NameCell,
  OpenStatus,
  QuickTasksCnt,
} from './quickTasks.style';
import CustomButton from 'components/Button/CustomButton';
import {
  IconButton,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useState } from 'react';
import AddAssigneeIcon from 'components/Icons/addAssigneeIcon';
import useCreateTask from 'utils/CustomHooks/useCreateTask';
import ArrowRight from '@mui/icons-material/KeyboardArrowRight';
import CrossIcon from 'components/Icons/crossIcon';
import selectors from 'store/selectors';
import { getItem, removeItem } from 'utils/globalFunction';
import { useSelector } from 'react-redux';
import { useWorkspaceHook } from 'utils/CustomHooks/useWorkspaceHook';
import { useOnboardState } from '../onboarding-provider';

const categoryColors = [
  {
    bg: '#E8EAF6',
    color: '#303F9F',
  },
  {
    bg: '#FBE9E7',
    color: '#E64A19',
  },
  {
    bg: '#E1F5FE',
    color: '#0288D1',
  },
];

const QuickTasks = (props) => {
  const { nextStep } = props;
  const { navigateWithWorkspaceUrl } = useWorkspaceHook();
  const { hotelId } = useOnboardState();
  const userProfileData = useSelector(selectors.getUserProfile);
  const { createTaskQuick } = useCreateTask();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([
    { title: '' },
    { title: '' },
    { title: '' },
  ]);

  const [fieldFocus, setFieldFocus] = useState(-1);

  const updateData = (value, index) => {
    const newArr = [...data];
    newArr[index].title = value;

    setData(newArr);
  };

  const handleRedirect = () => {
    const workspaceId =
      userProfileData?.HotelId ||
      userProfileData?.UserHotels?.[0]?.Hotel?.id ||
      hotelId;

    const templateId = getItem('template-id');

    if (templateId) {
      navigateWithWorkspaceUrl(
        `/checklist?template-id=${templateId}`,
        workspaceId,
        {
          replace: true,
        },
      );
      removeItem('template-id');
    } else {
      navigateWithWorkspaceUrl('/tasks/list', hotelId, {
        replace: true,
      });
    }
  };

  const submitTasks = async () => {
    const payload = data.filter((item) => item?.title != '');
    if (payload?.length === 0) {
      handleRedirect();
      return;
    }
    setLoading(true);
    const taskResponse = await createTaskQuick(payload);
    setLoading(false);
    if (taskResponse) {
      handleRedirect();
    }
  };

  return (
    <QuickTasksCnt>
      <div className="create-tasks">
        <div className="addOption">
          <div className="iconCnt">
            <AddIcon style={{ color: 'white' }} />
          </div>
          <CTypography className="title">
            Let’s create a few quick tasks
          </CTypography>
        </div>

        <CustomInput
          muiLabel={false}
          grayInput={true}
          fieldProps={{
            autoFocus: true,
            placeholder: fieldFocus === 0 ? 'Enter task name' : 'Task name',
            inputProps: { style: { padding: '15px 12px' } },
            onChange: (e) => updateData(e.target.value, 0),
            value: data?.[0]?.title,
            onFocus: () => {
              setFieldFocus(0);
            },
            onBlur: () => {
              setFieldFocus(-1);
            },
            endAdornment: (
              <InputAdornment position="end">
                <CrossIconBtn
                  className="closeIcon"
                  onClick={() => {
                    updateData('', 0);
                  }}
                >
                  <CrossIcon />
                </CrossIconBtn>
              </InputAdornment>
            ),
          }}
        />

        <CustomInput
          muiLabel={false}
          grayInput={true}
          fieldProps={{
            placeholder: fieldFocus === 1 ? 'Enter task name' : 'Task name',
            inputProps: { style: { padding: '15px 12px' } },
            onChange: (e) => updateData(e.target.value, 1),
            value: data?.[1]?.title,
            onFocus: () => {
              setFieldFocus(1);
            },
            onBlur: () => {
              setFieldFocus(-1);
            },
            endAdornment: (
              <InputAdornment position="end">
                <CrossIconBtn
                  className="closeIcon"
                  onClick={() => {
                    updateData('', 1);
                  }}
                >
                  <CrossIcon />
                </CrossIconBtn>
              </InputAdornment>
            ),
          }}
        />

        <CustomInput
          muiLabel={false}
          grayInput={true}
          fieldProps={{
            placeholder: fieldFocus === 2 ? 'Enter task name' : 'Task name',
            inputProps: { style: { padding: '15px 12px' } },
            onChange: (e) => updateData(e.target.value, 2),
            value: data?.[2]?.title,
            onFocus: () => {
              setFieldFocus(2);
            },
            onBlur: () => {
              setFieldFocus(-1);
            },
            endAdornment: (
              <InputAdornment position="end">
                <CrossIconBtn
                  className="closeIcon"
                  onClick={() => {
                    updateData('', 2);
                  }}
                >
                  <CrossIcon />
                </CrossIconBtn>
              </InputAdornment>
            ),
          }}
        />

        <div className="footerCnt">
          <div className="innerCnt">
            <CustomButton
              color="primary"
              variant="outlined"
              onClick={() => nextStep({ HotelId: hotelId }, true, true)}
            >
              Previous
            </CustomButton>
            <CustomButton
              color="primary"
              variant="contained"
              onClick={submitTasks}
              endIcon={<ArrowRight />}
              buttonLoader={loading}
            >
              Next
            </CustomButton>
          </div>
        </div>
      </div>
      <div className="show-tasks">
        <div className="content">
          <CTypography className="title">Tasks & Work Orders</CTypography>

          <TableContainer>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow sx={{ backgroundColor: '#ECEFF1', height: 20 }}>
                  <TableCell sx={{ width: '100px' }}>
                    <CTypography className="colHead">Title</CTypography>
                  </TableCell>
                  <TableCell align="center">
                    <CTypography className="colHead">Status</CTypography>
                  </TableCell>
                  <TableCell align="center">
                    <CTypography className="colHead">Location</CTypography>
                  </TableCell>
                  <TableCell align="center">
                    <CTypography className="colHead">Category</CTypography>
                  </TableCell>
                  <TableCell align="center">
                    <CTypography className="colHead">Assignee</CTypography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((item, index) => (
                  <TableRow
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell
                      sx={{ width: '200px' }}
                      component="th"
                      scope="row"
                    >
                      <NameCell>{item?.title || 'Task name'}</NameCell>
                    </TableCell>
                    <TableCell align="center">
                      <OpenStatus>
                        <CTypography>Open</CTypography>
                      </OpenStatus>
                    </TableCell>
                    <TableCell align="center">
                      <LocationCnt>
                        <CTypography>Location</CTypography>
                      </LocationCnt>
                    </TableCell>
                    <TableCell align="center">
                      <CategoryCnt
                        bg={categoryColors[index].bg}
                        color={categoryColors[index].color}
                      >
                        <CTypography>Category</CTypography>
                      </CategoryCnt>
                    </TableCell>
                    <TableCell align="center">
                      <AssigneeCnt>
                        <div className="innerCnt">
                          <AddAssigneeIcon
                            style={{
                              height: 17,
                              width: 17,
                            }}
                          />
                        </div>
                      </AssigneeCnt>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </QuickTasksCnt>
  );
};

export default QuickTasks;
